import type { FaireProductEntity } from "../../entity_types/product";

export const p_zta8n9x7js: FaireProductEntity = {
  token: "p_zta8n9x7js",
  type: "product",
  name: "Elegant Gold Plated Multi-Color Chain Bracelet DP26I561",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Dipped Shop",
  imageUrl: "https://cdn.faire.com/fastly/8680746065125278a36b2263b5d7b22b8af96f12765e8c6b7872581dedd572a6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0a72228cc93af5db683625a266b71b93b93934ce3708c8cbbbe768e4f445f3f4.jpeg",
    "https://cdn.faire.com/fastly/53e1a636fa449a67ccbadb93c78e789981c908337d5ed01bede007d69cdf195a.jpeg",
    "https://cdn.faire.com/fastly/9baa18c74dc12a578df14886dfceb9822d30f10d073f910ce8c5a8b86d22ec9e.jpeg",
    "https://cdn.faire.com/fastly/0833157f6450b526f414e89d1cc344992d3e8ae0f468b82b8eb151737209a34e.jpeg",
    "https://cdn.faire.com/fastly/f09db2c0d7eed4acc50e92a37e12652f6d5d379afd6e7d97158ee142f54a6877.jpeg",
    "https://cdn.faire.com/fastly/530d2ebc1af2eb03113e24ba761e0b629a12c9ba7d08b01864bec4c9ca101219.jpeg"
  ],
  priceDollars: 4.14,
  description: "Feature:\n * Trendy, Minimalist\n * Gold Plated\n * Multi-Color\n * Lightweight\n * Layered Wear\n * Splicing, Adjustable\n * Versatile, Delicate \n * Daily Fitting\n * Gift\n\n Weigh:\n * 10g\n\n Material:\n * Copper\n\n Package:\n * Package include 1 bracelet.\n\n Note:\n * Manual measurement, due to different measurement methods, 1-3CM error is a normal phenomenon\n * Due to the different shooting lights and electronic screen display, the color of the model image will be different. The color of a single product is subject to the actual product. ",
  tags: [],
  msrpDollars: 8.29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:02.620Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
